import { useState, useEffect } from 'react'
import { getFirestore, collection, onSnapshot } from 'firebase/firestore'
import { isDevAuthBypass } from '@/lib/firebase'

export function useSlideCommentCounts(deckSlug: string) {
  const [counts, setCounts] = useState<Record<number, number>>({})
  const [totalUnresolved, setTotalUnresolved] = useState(0)

  useEffect(() => {
    if (isDevAuthBypass) return
    const db = getFirestore()
    const commentsRef = collection(db, 'decks', deckSlug, 'comments')

    const unsub = onSnapshot(commentsRef, snap => {
      const map: Record<number, number> = {}
      let total = 0
      snap.docs.forEach(d => {
        const data = d.data()
        // Only count unresolved top-level comments
        if (data.parentId === null && data.resolved !== true) {
          const idx = data.slideIndex ?? 0
          map[idx] = (map[idx] || 0) + 1
          total++
        }
      })
      setCounts(map)
      setTotalUnresolved(total)
    })

    return unsub
  }, [deckSlug])

  return { counts, totalUnresolved }
}
